import { createProductQueryClient } from "@vjal/frontend-core";

/** Coaching boot factory — product QueryClient (F4). */
export function createCoachingQueryClient() {
  return createProductQueryClient({
    staleTime: 30_000,
    maxRetries: 1,
  });
}
